var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(_vm.isNotFullLayout)?[_c('Sidebar'),_c('Header')]:_vm._e(),_c('v-main',{staticClass:"content"},[_c('router-view',{key:_vm.$route.fullPath})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }